export default __webpack_public_path__ + "static/media/smartphone-2.fb44e54d.svg";